// extracted by mini-css-extract-plugin
module.exports = {"camera-off":"style_camera-off__s0s0M","camera-off-icon":"style_camera-off-icon__Wq7MC","camera-off-text":"style_camera-off-text__LSrJj"};